import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { GetQuotesResponse, GetReminderQuotesProps } from 'shared/services';

export function useQueryReminderQuotes(props: GetReminderQuotesProps) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetching } = useQuery<GetQuotesResponse, Error>(
    'quote-reminders',
    () => quoteService.getReminderQuotes(props),
    {
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
      keepPreviousData: true,
    }
  );
  return { quotes: data, isLoading, isFetching } as const;
}
